import { createServiceStore } from 'common/store';
import { customActions } from './custom-actions';
import { initialState } from './constants';
export var useToastServiceStore = createServiceStore({
    initialValues: initialState,
    customActions: customActions,
});
